<template>
	<div class="select-1">
		<span class="cntitle">{{mainWord.chTitle}}</span>
		<span class="mainword-inner">{{mainWord.main}}</span>
		<div class="introduct-img">
			<div class="imgwrapper" v-for="item in mainImg">
				<img :src="'static/image/serive-img/' + item + '.jpg'"/>
			</div>
		</div>
	</div>
</template>

<script type="text/ecmascript-6">
export default {
	data() {
		return {
			mainImg: [1,2,3]
		}
	},
	computed: {
		mainWord() {
			return this.$t('mainWord')
		}
	}
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
	@import "~common/stylus/variable"
	
	.cntitle
		font-size: $font-web-medium
		text-align: center
		@media screen and (max-width:550px)
			font-size: $font-web-small-l
	.entitle
		font-size: $font-web-small
	.circle
		font-size: $font-web-large
	.mainword-inner
		display: block
		line-height: $font-web-medium
		padding-top: 40px
		border-top: 1px solid $color-theme
		@media screen and (max-width:550px)
			font-size: $font-web-small-s
			padding-top: 20px
	.introduct-img
		display: flex
		justify-content: space-between
		margin-right: -20px
		@media screen and (max-width:550px)
			display: block
		.imgwrapper
			flex: 1
			img
				width: 100%
				margin: 80px auto 0
				padding-right: 20px
				@media screen and (max-width:550px)
					margin: 20px auto
</style>



// WEBPACK FOOTER //
// src/components/tab-item/first-introduce.vue